export const SOCKET_EVENT_RECEIVED = 'SOCKET_EVENT_RECEIVED';
export const SOCKET_EVENT_IGNORED = 'SOCKET_EVENT_IGNORED';
export const UPDATE_OMS_ORDER_NUMBER = 'UPDATE_OMS_ORDER_NUMBER';
export const AIO_DXG_EVENTS = 'AIO_DXG_EVENTS';
